import * as React from 'react';
import AccordionItem from './accordion-item.component';
import { isFunction } from 'lodash';

import './accordion.styles.less';

import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

export default class Accordion extends React.Component<IAccordionProps, IAccordionState> {
    public state: IAccordionState = {
        sections: this.props.items
    };

    public componentDidUpdate(prevProps: IAccordionProps) {
        if (prevProps.isAllCollapsed === this.props.isAllCollapsed) {
            return;
        }

        return this.setState({ sections: this.props.items });
    }

    public onSectionClick = (sectionId: number) => {
        const { sections } = this.state;
        const { analyticsAttributes } = this.props;
        const clickedSection = sections[sectionId];
        clickedSection.isOpen = !clickedSection.isOpen;

        this.setState({ sections });

        if (isFunction(analyticsAttributes) ) {
            const itemReference = `${this.props.id}-${sectionId}`;
            AnalyticsService.sendFlowEvent(analyticsAttributes(itemReference));
        }
    };

    public renderSections = (): JSX.Element[] => (
        this.state.sections.map((item, index) => (
            <AccordionItem
                key={index}
                id={index}
                onClick={this.onSectionClick}
                {...item}
            />
        ))
    );

    public render(): JSX.Element {
        const { title } = this.props;

        return (
            <div className="sitegen-accordion">
                <div className="sitegen-accordion__title">{title}</div>
                <div className="sitegen-accordion-section">
                    {this.renderSections()}
                </div>
            </div>
        );
    }
}

interface IAccordionSection {
    [key: string]: React.ReactNode;
    isOpen: boolean;
}

export interface IAccordionProps {
    readonly id: number;
    readonly title: React.ReactNode;
    readonly items: Array<IAccordionSection>;
    readonly isAllCollapsed?: boolean;
    readonly analyticsAttributes?: (itemReference: string) => object;
}

export interface IAccordionState {
    sections: Array<IAccordionSection>;
}

export {
    AccordionItem
};
